import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/promiseFrame/nevsCardLineBlue.png'
import _imports_1 from '../../../../../assets/promiseFrame/nevsCardLineGreen.png'
import _imports_2 from '../../../../../assets/promiseFrame/268Logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-be9d170c")

_pushScopeId("data-v-be9d170c")
const _hoisted_1 = { class: "nevsCard" }
const _hoisted_2 = { class: "cardBox" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Проверка авто")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Проверка батареи")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_9 = { class: "cardCont" }
const _hoisted_10 = { class: "cardContItem cardContBlue" }
const _hoisted_11 = { class: "cardService" }
const _hoisted_12 = { class: "cardLevel" }
const _hoisted_13 = { class: "resultTxt" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "resTag" }, "Результат проверки", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "tag-circle-container" }
const _hoisted_17 = { class: "resbox" }
const _hoisted_18 = { class: "rectangle_resBox" }
const _hoisted_19 = { class: "rectangle_resBox_item" }
const _hoisted_20 = { class: "rectangle_resBox_item_txt" }
const _hoisted_21 = { class: "rectangle_resBox_item" }
const _hoisted_22 = { class: "rectangle_resBox_item_txt" }
const _hoisted_23 = { class: "rectangle_resBox_item" }
const _hoisted_24 = { class: "rectangle_resBox_item_txt" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "nevsCardLine" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_26 = {
  key: 0,
  class: "circle"
}
const _hoisted_27 = { class: "circleItemSlot" }
const _hoisted_28 = { class: "errNum" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_30 = { class: "totalNum" }
const _hoisted_31 = { class: "circleItemTxt" }
const _hoisted_32 = { class: "cardContItem cardContGreen" }
const _hoisted_33 = { class: "cardService" }
const _hoisted_34 = { class: "cardLevel" }
const _hoisted_35 = { class: "reportLevel" }
const _hoisted_36 = { class: "levelNum" }
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-yiwen" }, null, -1)
const _hoisted_38 = { class: "resbox" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "resTag" }, "Результат проверки", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "cardResult"
}
const _hoisted_42 = { class: "cardResTop" }
const _hoisted_43 = { class: "res-col" }
const _hoisted_44 = { class: "res-num" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "res-desc" }, "Количество циклов зарядки", -1)
const _hoisted_47 = { class: "res-col" }
const _hoisted_48 = { class: "res-num" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "res-desc" }, "Расчётный запас хода при полной зарядке", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "nevsCardLine" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_1 })
], -1)
const _hoisted_52 = { class: "circle" }
const _hoisted_53 = { class: "circleCont" }
const _hoisted_54 = {
  key: 0,
  class: "circleItemSlot normalTxt"
}
const _hoisted_55 = {
  key: 1,
  class: "circleItemSlot"
}
const _hoisted_56 = { class: "errNum" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_58 = { class: "totalNum" }
const _hoisted_59 = {
  key: 2,
  class: "circleItemSlot"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "totalNum" }, "-", -1)
const _hoisted_61 = { class: "circleItemTxt" }
const _hoisted_62 = { class: "reportMsgCont" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "localIcon",
    src: _imports_2
  })
], -1)
const _hoisted_64 = { class: "reportMsg" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { class: "batteryPop" }
const _hoisted_67 = { class: "batteryPopTitle" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Описание оценки аккумулятора ")
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"batteryPopCont\" data-v-be9d170c><div class=\"batteryPopContTitle\" data-v-be9d170c><i class=\"batteryPopContTitleLine\" data-v-be9d170c></i><span class=\"batteryPopContTitleTxt\" data-v-be9d170c>Рейтинг аккумулятора (S/D)</span></div><div class=\"batteryPopContTxt\" data-v-be9d170c> S: Тяговая батарея не имеет потенциальных рисков безопасности.<br data-v-be9d170c> D: Тяговая батарея имеет потенциальные риски безопасности. </div><div class=\"batteryPopContTitle\" data-v-be9d170c><i class=\"batteryPopContTitleLine\" data-v-be9d170c></i><span class=\"batteryPopContTitleTxt\" data-v-be9d170c>Оценка состояния аккумулятора</span></div><div class=\"batteryPopContTxt\" data-v-be9d170c> SOH (состояние здоровья аккумулятора): показывает состояние аккумулятора в процентах. SOH = (текущая максимальная ёмкость тяговой батареи ÷ номинальная ёмкость тяговой батареи) × 100 %. </div><div class=\"batteryPopTable\" data-v-be9d170c><div class=\"batteryPopTableTh\" data-v-be9d170c>Рейтинг SOH 268V</div><div class=\"batteryPopTableTr\" data-v-be9d170c><div class=\"batteryPopTableTd col1\" data-v-be9d170c>Отличный</div><div class=\"batteryPopTableTd col2\" data-v-be9d170c>90% и выше (включительно)</div></div><div class=\"batteryPopTableTr\" data-v-be9d170c><div class=\"batteryPopTableTd col1\" data-v-be9d170c>Хороший</div><div class=\"batteryPopTableTd col2\" data-v-be9d170c>От 80% (включительно) до 90%</div></div><div class=\"batteryPopTableTr\" data-v-be9d170c><div class=\"batteryPopTableTd col1\" data-v-be9d170c>Средний</div><div class=\"batteryPopTableTd col2\" data-v-be9d170c>От 65% (включительно) до 80%</div></div><div class=\"batteryPopTableTr\" data-v-be9d170c><div class=\"batteryPopTableTd col1\" data-v-be9d170c>Обычный</div><div class=\"batteryPopTableTd col2\" data-v-be9d170c>Ниже 65%</div></div><div class=\"batteryPopTableTend\" data-v-be9d170c> Примечание: Измеренное значение SOH тяговой батареи выражается в процентах. При отображении рейтинга батареи показывается только числовое значение перед символом процента. </div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_circleCom = _resolveComponent("circleCom")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["cardTab", {'activeGreen': _ctx.state.activeTab === 1,
                'activeBlue': _ctx.state.activeTab === 0
            }]
      }, [
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 0}],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(0)))
        }, [
          _createVNode("p", null, [
            _hoisted_3,
            _hoisted_4,
            _createVNode("b", null, _toDisplayString(_ctx.getData('rank')), 1)
          ]),
          _hoisted_5
        ], 2),
        _createVNode("div", {
          class: ["cardTabItem", {'active': _ctx.state.activeTab === 1}],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(1)))
        }, [
          _createVNode("p", null, [
            _hoisted_6,
            _hoisted_7,
            _createVNode("b", null, _toDisplayString(_ctx.getData('batteryDetectLevel')) + _toDisplayString(_ctx.getData('soh') === '-' ? '' : _ctx.getData('soh')), 1)
          ]),
          _hoisted_8
        ], 2)
      ], 2),
      _createVNode("div", _hoisted_9, [
        _withDirectives(_createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.state.promiseTxt), 1),
          _createVNode("div", _hoisted_12, [
            _createVNode("img", {
              class: "levelImg",
              src: require(`../../../../../assets/batteryFrame/nevs_level_${_ctx.getData('rank')}En.png`)
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.getData('rankDesc')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("ul", _hoisted_18, [
                _createVNode("li", _hoisted_19, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('accidentFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_20, _toDisplayString(_ctx.getData('accidentFlag')), 1)
                ]),
                _createVNode("li", _hoisted_21, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('fireFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_22, _toDisplayString(_ctx.getData('fireFlag')), 1)
                ]),
                _createVNode("li", _hoisted_23, [
                  _createVNode("img", {
                    src: require(`../../../../../assets/promiseFrame/${_ctx.getData('waterFlag', 'additionUrl')}`),
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("p", _hoisted_24, _toDisplayString(_ctx.getData('waterFlag')), 1)
                ])
              ])
            ]),
            _hoisted_25,
            (_ctx.isShowBatteryOtherMsg)
              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.blueCircleList, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "circleItem",
                      key: item.name,
                      onClick: ($event: any) => (_ctx.clickTab(item.clickToId))
                    }, [
                      _createVNode(_component_circleCom, {
                        strokeWidth: _ctx.state.blueCircleWidth,
                        currentGradient: _ctx.state.blueCircle,
                        progress: _ctx.setProgress(item),
                        circleId: item.name
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_27, [
                            _createVNode("span", _hoisted_28, _toDisplayString(item.error), 1),
                            _hoisted_29,
                            _createVNode("span", _hoisted_30, _toDisplayString(item.total), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["strokeWidth", "currentGradient", "progress", "circleId"]),
                      _createVNode("div", _hoisted_31, _toDisplayString(item.nameTxt), 1)
                    ], 8, ["onClick"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.state.activeTab === 0]
        ]),
        _withDirectives(_createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, _toDisplayString(_ctx.state.promiseTxt), 1),
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("h5", {
                class: "levelTxt",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
              }, [
                _createVNode("span", _hoisted_36, _toDisplayString(_ctx.getData('batteryDetectLevel')) + _toDisplayString(_ctx.getData('soh') === '-' ? '' : _ctx.getData('soh')), 1),
                _hoisted_37
              ]),
              _createVNode("img", {
                class: "levelImg",
                src: require('../../../../../assets/promiseFrame/batteryCar.png')
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_38, [
              _hoisted_39,
              _hoisted_40,
              _createTextVNode(" " + _toDisplayString(_ctx.getData('batteryDetectLevelDesc')), 1)
            ])
          ]),
          (_ctx.isShowBatteryOtherMsg)
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, [
                      _createTextVNode(_toDisplayString(_ctx.getData('numberOfCycles')), 1),
                      (_ctx.getData('numberOfCycles') !== '-' )
                        ? (_openBlock(), _createBlock("span", _hoisted_45, "Раз"))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_46
                  ]),
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _createTextVNode(_toDisplayString(_ctx.getData('kmRemain')), 1),
                      (_ctx.getData('kmRemain') !== '-' )
                        ? (_openBlock(), _createBlock("span", _hoisted_49, "Km"))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_50
                  ])
                ]),
                _hoisted_51,
                _createVNode("div", _hoisted_52, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.greenCircleList, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "circleItem",
                      key: item.name,
                      onClick: ($event: any) => (_ctx.clickTab(item.clickToId))
                    }, [
                      _createVNode("div", _hoisted_53, [
                        _createVNode(_component_circleCom, {
                          strokeWidth: _ctx.state.greenCircleWidth,
                          currentGradient: _ctx.setCircleGradient(item),
                          progress: _ctx.setProgress(item),
                          circleId: item.name
                        }, {
                          default: _withId(() => [
                            (item.type === 'normal')
                              ? (_openBlock(), _createBlock("div", _hoisted_54, _toDisplayString(_ctx.setCircleGradient(item).contTxt), 1))
                              : (item.total)
                                ? (_openBlock(), _createBlock("div", _hoisted_55, [
                                    _createVNode("span", _hoisted_56, _toDisplayString(item.error), 1),
                                    _hoisted_57,
                                    _createVNode("span", _hoisted_58, _toDisplayString(item.total), 1)
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_59, [
                                    _hoisted_60
                                  ]))
                          ]),
                          _: 2
                        }, 1032, ["strokeWidth", "currentGradient", "progress", "circleId"])
                      ]),
                      _createVNode("div", _hoisted_61, _toDisplayString(item.nameTxt), 1)
                    ], 8, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.state.activeTab === 1]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_62, [
      _hoisted_63,
      _createVNode("div", _hoisted_64, [
        _createTextVNode(" NO." + _toDisplayString(_ctx.getData('reportCode')) + " ", 1),
        (_ctx.getData("reportGenDate"))
          ? (_openBlock(), _createBlock("span", _hoisted_65, " | " + _toDisplayString(_ctx.getData('reportGenDate').replace(/-/g,'.')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.state.isShowBatteryPop,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.isShowBatteryPop = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_66, [
          _createVNode("div", _hoisted_67, [
            _hoisted_68,
            _createVNode("i", {
              class: "iconfont icon-guanbi",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeBatteryPop && _ctx.changeBatteryPop(...args)))
            })
          ]),
          _hoisted_69
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})